import moment from 'moment';

export const getRegisterTouchpointGreetings = (): string => {
  const hoursIn24Hours = Number(moment().format('HH'));
  let greetingID = 'GoodMorning';
  if (hoursIn24Hours > 17) {
    greetingID = 'GoodEvening';
  } else if (hoursIn24Hours > 12) {
    greetingID = 'GoodAfternoon';
  }
  return greetingID;
};
